import { Spinner } from '@vst/beam';
import { useTranslation } from 'react-i18next';

export const SubTypeUpdateLoading = () => {
  const { t } = useTranslation('Network');

  return <Spinner size="large" description={t('networkManagement.switchLoading')} />;
};
